import JsCookies from 'js-cookie';
import type { CookiesStatic } from 'js-cookie';

const BrowserCookies: CookiesStatic & {
  getJSON<T = any>(name: string): T | null;
} = {
  attributes: JsCookies.attributes,
  converter: JsCookies.converter,

  get: JsCookies.get,

  set: JsCookies.set,

  remove: JsCookies.remove,

  withAttributes: JsCookies.withAttributes,

  withConverter: JsCookies.withConverter,

  getJSON<T = any>(name: string): T | null {
    try {
      const value = BrowserCookies.get(name);

      return value ? JSON.parse(value) : null;
    } catch (_e) {
      return null;
    }
  }
};

export default BrowserCookies;
